import { SearchOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Drawer, Empty, Input, Row, Spin, Image, message } from "antd";
import CustomImage from "app/components/CustomImage/CustomImage";
import LayoutTableV2 from "app/components/TableV2";
import { useHandleSubmitApi } from "hook";
import { IGetMediaForPaginateInputModel, IMediaOutputModel } from "interfaces/media";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { MediaServices } from "services/media";
import MediaInformationContent from "./MediaInformationContent/MediaInformationContent";
import "./MediaList.style.scss";
import MediaUploadModal from "./MediaUploadModal/MediaUploadModal.presenter";
import ModalConfirm from "app/components/ConfirmExit";

export interface IMediaPageProps {
  isHiddenBtnUpload?: boolean;
}

export default function MediaListPage(props: IMediaPageProps) {
  const { RangePicker } = DatePicker;
  const [list, setList] = useState<IMediaOutputModel[]>([]);
  const [searchValue, setSearchValue] = useState<string>("");
  const [totalRecord, setTotalRecord] = useState<number>(0);
  const [pageNum, setPageNum] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(30);
  const [dates, setDates] = useState([]);
  const [media, setMedia] = useState<IMediaOutputModel | null>(null);
  const [visibleUpload, setVisibleUpload] = useState(false);
  const [visibleRemove, setVisibleRemove] = useState<string | null>(null);

  useEffect(() => {
    handleFilter();
    // eslint-disable-next-line
  }, [dates, searchValue, pageNum, pageSize]);

  const handleFilter = () => {
    const filter: IGetMediaForPaginateInputModel = {
      pageSize: pageSize,
      pageNum: pageNum,
      searchValue: searchValue,
    };
    if (!!dates?.length) {
      filter["fromDate"] = dates[0];
      filter["toDate"] = dates[1];
    }
    getListMediaService(filter);
  };

  const [getListMediaService, loading] = useHandleSubmitApi(async (filter: IGetMediaForPaginateInputModel) => {
    const dataRes = await MediaServices.getMedia(filter);
    if (dataRes) {
      setTotalRecord(dataRes?.meta?.totalRecords);
      setList(dataRes?.data || []);
    }
  });

  const [removeMediaService, loadingRemoveMedia] = useHandleSubmitApi(async (mediaId: string) => {
    const dataRes = await MediaServices.removeMedia(mediaId);
    if (dataRes) {
      handleUpdateOrCreateCompleted();
      message.success("Xoá Media thành công!");
    }
  });

  const renderHeader = () => {
    return (
      <React.Fragment>
        <div className="layout-list__header__menu" style={{ width: "20rem" }}></div>
        <div className="d-flex">
          <RangePicker
            className="mr_1"
            onChange={(values: any, dateStrings) => setDates(values?.map((d: any) => new Date(d).toISOString()))}
            style={{ width: 300 }}
            placeholder={["Ngày Bắt Đầu", "Ngày Kết Thúc"]}
          />

          <Input
            placeholder="Nhập thông tin tìm kiếm"
            className="mr_1"
            suffix={<SearchOutlined />}
            onChange={_.debounce((e) => {
              setSearchValue(e.target.value);
              setPageNum(1);
              setPageSize(30);
            }, 200)}
            style={{ width: 200 }}
            allowClear
          />

          {props?.isHiddenBtnUpload ? (
            <></>
          ) : (
            <Button
              size="large"
              className="btn"
              style={{ width: 200 }}
              disabled={loading}
              loading={loading}
              onClick={() => setVisibleUpload(true)}
            >
              Thêm ảnh mới
            </Button>
          )}
        </div>
      </React.Fragment>
    );
  };

  const renderContent = () => {
    return (
      <Spin size="large" spinning={loading}>
        <Row gutter={[20, 20]} className="media-list-body">
          {list?.length ? (
            [...list]?.map((l) => {
              const url = l.path;
              return (
                <Col key={l.id} xxl={3} xl={4} lg={6} md={8} sm={10} xs={24} className="media-list-body__item">
                  <CustomImage src={url} alt={l.title} onClick={() => setMedia(l)} />
                </Col>
              );
            })
          ) : (
            <Col span={24}>
              <Empty />
            </Col>
          )}
        </Row>
      </Spin>
    );
  };

  const handleUpdateOrCreateCompleted = () => {
    handleFilter();
    setMedia(null);
    setVisibleUpload(false);
  };

  const renderDrawer = () => {
    return (
      <Drawer
        rootClassName="media-list-information"
        title="Chi tiết hình ảnh"
        onClose={() => {
          setMedia(null);
        }}
        open={!!media}
        width={"100%"}
        footer={
          <div className="media-list-information__footer">
            <div className="media-list-information__footer-left">
              <Button
                size="large"
                className="btn btn-outline"
                style={{ width: 200, color: "red", borderColor: "red" }}
                onClick={() => media?.id && setVisibleRemove(media.id)}
                disabled={loadingRemoveMedia}
                loading={loadingRemoveMedia}
              >
                Xoá Media
              </Button>
            </div>
            <div className="media-list-information__footer-right">
              {/* <Button
                size="large"
                className="btn"
                style={{ width: 200 }}
                // onClick={() => handleSubmit()}
                // disabled={loadingMedia}
                // loading={loadingMedia}
              >
                Lưu thông tin
              </Button> */}
            </div>
          </div>
        }
      >
        <Row gutter={[50, 20]} className="media-list-information__body">
          <Col span={16} className="media-list-information__body-left">
            <>
              <div className="media-list-information__body-left_image">
                <Image src={media?.path} alt={media?.title} />
              </div>
            </>
          </Col>
          <Col span={8} className="media-list-information__body-right">
            {!!media ? (
              <MediaInformationContent data={media} onUpdateOrCreateCompleted={handleUpdateOrCreateCompleted} />
            ) : (
              <></>
            )}
          </Col>
        </Row>
      </Drawer>
    );
  };

  return (
    <React.Fragment>
      {visibleUpload && (
        <MediaUploadModal
          activeKey="1"
          visible={visibleUpload}
          onClose={() => setVisibleUpload(false)}
          onUploadCompleted={handleUpdateOrCreateCompleted}
        />
      )}

      {!!visibleRemove && (
        <ModalConfirm
          visible={!!visibleRemove}
          title="Bạn có chắc chắn muốn xoá?"
          cancel={() => setVisibleRemove(null)}
          confirm={async () => {
            await removeMediaService(visibleRemove);
            setVisibleRemove(null);
            // navigate(PAGE_ROUTE.ADM_POST);
            // props.onClose();
          }}
        />
      )}

      {renderDrawer()}

      <LayoutTableV2<IMediaOutputModel>
        header={() => <React.Fragment>{renderHeader()}</React.Fragment>}
        body={() => <React.Fragment>{renderContent()}</React.Fragment>}
        data={list.map((l) => ({ ...l, key: l.id }))}
        columns={[]}
        optionPaginate={{
          numberRecordShow: list.length,
          totalRecord: totalRecord,
          pageNum: pageNum,
          pageSize: pageSize,
          onChangePageNum: (number) => {
            setPageNum(number);
          },
          onShowSizeChange: (curr, size) => {
            setPageSize(size);
          },
        }}
      />
    </React.Fragment>
  );
}
